<div class="card mb-4">
    <!-- Skeleton para evitar shift -->
    <div *ngIf="displayAguarde" >
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
    </div>
    <!-- <div class="p-fluid grid"> -->
    <!-- contas -->
    <div *ngIf="!displayAguarde" class="cursor-pointer">
        <div class="flex align-items-center" [class.mb-3]="!collapsed.igMain" (click)="toggle('igMain')">
            <i class="pi pi-instagram mr-2" style="font-size: 2.5rem;"></i>
            <div>
                <div class="font-bold">Instagram</div>
                <div class="text-sm text-500">{{ getMainText() }}</div>
            </div>

            <!-- seta à direita -->
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.igMain }"></i>
        </div>
    </div>

    <div class="collapsible" [class.collapsed]="collapsed.igMain" *ngIf="showConectAccount && !displayAguarde">
        <div class="collapsible__inner">
            <div class="" *ngIf="showConectAccount && !displayAguarde">
                <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
                    style="padding: 1.5rem;" (click)="conectInstagram()">
                    <img src="assets/logo_instagram_recortado.png" width="36" class="mb-2" />
                    <span class="font-semibold mb-1">Instagram Business</span>
                    <span class="text-sm text-500 mb-2">A autenticação é feita via Facebook</span>
                    <button type="button" class="ss-l-fb-btn" (click)="$event.stopPropagation(); conectInstagram()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white" style="flex-shrink:0">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                        Continuar com Facebook
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="collapsible" [class.collapsed]="collapsed.igMain" *ngIf="!showConectAccount && !displayAguarde">
        <div class="collapsible__inner">
            <div class="w-full" *ngIf="!showConectAccount && !displayAguarde">
                <p-dropdown [options]="facebookAccounts" [(ngModel)]="selectedAccountId" optionLabel="label"
                    optionValue="value" placeholder="-- selecione a conta do Facebook --" styleClass="w-full"
                    [appendTo]="'body'" (onChange)="onSelectAccount($event.value)">
                    <ng-template let-o pTemplate="item">
                        <div class="flex align-items-center">
                            <ng-container *ngIf="o.value !== 'add_account'; else addAccountItem">
                                <img [src]="o.picture" width="24" class="mr-2" />
                                {{ o.label }}
                            </ng-container>
                            <ng-template #addAccountItem>
                                <i class="pi pi-plus mr-2"></i>
                                {{ o.label }}
                            </ng-template>
                        </div>
                    </ng-template>
                    <ng-template let-o pTemplate="selectedItem">
                        <div class="flex align-items-center">
                            <ng-container *ngIf="o.value !== 'add_account'; else addAccountSelected">
                                <img [src]="o.picture" width="24" class="mr-2" />
                                {{ o.label }}
                            </ng-container>
                            <ng-template #addAccountSelected>
                                <i class="pi pi-plus mr-2"></i>
                                {{ o.label }}
                            </ng-template>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>

            <!-- Página do Facebook (seleção explícita — uso: pages_read_engagement) -->
            <div class="w-full mt-3" *ngIf="selectedFacebookAccountId && !showConectAccount && !displayAguarde">
                <label class="ss-g-globalClassLabel">Página do Facebook</label>
                <div class="mb-2"></div>
                <p-dropdown [options]="facebookPages" [(ngModel)]="selectedPageId" optionLabel="name"
                    optionValue="id" placeholder="-- selecione a Página --" [loading]="loadingFacebookPages"
                    styleClass="w-full" [appendTo]="'body'" (onChange)="onSelectFacebookPage($event.value)">
                    <ng-template let-o pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <img *ngIf="o.picture" [src]="o.picture" width="24" height="24" class="border-circle" />
                            <i *ngIf="!o.picture" class="pi pi-facebook text-blue-600"></i>
                            <span class="flex-1">{{ o.name }}</span>
                            <span *ngIf="o.followers_count !== null && o.followers_count !== undefined"
                                class="text-xs text-500 flex align-items-center gap-1">
                                <i class="pi pi-users"></i>{{ o.followers_count | number }}
                            </span>
                        </div>
                    </ng-template>
                    <ng-template let-o pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2">
                            <img *ngIf="o.picture" [src]="o.picture" width="24" height="24" class="border-circle" />
                            <i *ngIf="!o.picture" class="pi pi-facebook text-blue-600"></i>
                            <span class="flex-1">{{ o.name }}</span>
                            <span *ngIf="o.followers_count !== null && o.followers_count !== undefined"
                                class="text-xs text-500 flex align-items-center gap-1">
                                <i class="pi pi-users"></i>{{ o.followers_count | number }}
                            </span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>

            <!-- Ver posts da Página do Facebook (sob demanda — uso: pages_read_engagement) -->
            <div class="mt-2 text-left" *ngIf="selectedPageId && !showConectAccount && !displayAguarde">
                <a class="cursor-pointer text-primary font-medium" (click)="abrirPostagensPagina()">Ver posts do Facebook</a>
            </div>

            <p-dialog header="Posts da Página do Facebook" [(visible)]="pageFeedDialogVisible" [modal]="true"
                [dismissableMask]="true" styleClass="dialog1 ss-g-dialog-sized" appendTo="body">
                <div class="flex align-items-center justify-content-between gap-2 mb-3 pb-3 border-bottom-1 surface-border"
                    *ngIf="pageFeedInfo">
                    <div class="flex align-items-center gap-2">
                        <img *ngIf="pageFeedInfo.picture" [src]="pageFeedInfo.picture" width="40" height="40"
                            class="border-circle" />
                        <div class="font-semibold">{{ pageFeedInfo.name }}</div>
                    </div>
                    <div *ngIf="pageFeedInfo.followers_count !== null" class="text-sm text-500 flex align-items-center gap-1">
                        <i class="pi pi-users"></i>{{ pageFeedInfo.followers_count | number }} seguidores
                    </div>
                </div>
                <ng-container *ngIf="!loadingPageFeed; else loadingFeedTemplate">
                    <div *ngIf="pageFeedItems.length === 0" class="text-500 text-sm">
                        Nenhuma postagem encontrada nesta Página.
                    </div>
                    <!-- Grid de 2 colunas — sem isso a imagem ocupa a largura toda do dialog e
                         fica enorme; a versão pequena/compacta (mesmo padrão do resultado de
                         busca por hashtag) depende da coluna estreitar o item, não só de uma
                         altura fixa na imagem. -->
                    <div class="grid" *ngIf="pageFeedItems.length > 0">
                        <div class="col-12 sm:col-6" *ngFor="let post of pageFeedItems">
                            <a class="card m-0 p-2 h-full shadow-none border-1 surface-border block no-underline text-color-secondary"
                                [class.cursor-pointer]="post.permalink_url" [attr.href]="post.permalink_url || null"
                                target="_blank">
                                <img *ngIf="post.full_picture" [src]="post.full_picture"
                                    class="w-full h-10rem object-cover border-round mb-2" />
                                <div class="text-sm text-color mb-1"
                                    style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                    {{ post.message || '(sem texto)' }}
                                </div>
                                <div class="text-xs text-500 mb-1">
                                    <i class="pi pi-calendar mr-1"></i>{{ post.created_time | date:'dd/MM/yyyy HH:mm' }}
                                </div>
                                <span *ngIf="post.permalink_url" class="text-sm text-primary">Ver no Facebook</span>
                            </a>
                        </div>
                    </div>
                    <div *ngIf="hasMorePageFeed" class="text-center">
                        <button pButton type="button" [loading]="loadingMorePageFeed"
                            label="Carregar mais" (click)="loadMorePageFeed()" class="mt-2 load-more-btn"></button>
                    </div>
                </ng-container>
                <ng-template #loadingFeedTemplate>
                    <p-skeleton width="100%" height="1.5rem" class="mb-2"></p-skeleton>
                    <p-skeleton width="100%" height="8rem" class="mb-2"></p-skeleton>
                    <p-skeleton width="60%" height="1rem"></p-skeleton>
                </ng-template>
            </p-dialog>

            <!-- mostra dados da conta IG (uso: instagram_basic) -->
            <div *ngIf="selectedPage && !showConectAccount && !displayAguarde" class="mt-4">
                <label class="ss-g-globalClassLabel">Página do Instagram Vinculada</label>
                <div class="mb-2"></div>
                <div class="card shadow-none border-1 surface-border">
                <ng-container *ngIf="instagramAccount; else noIg">
                    <div class="flex align-items-center gap-3">
                        <div style="width:72px; height:72px; border-radius:50%; overflow:hidden; flex-shrink:0; background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); display:flex; align-items:center; justify-content:center;">
                            <img *ngIf="instagramAccount.picture" [src]="instagramAccount.picture" alt="ig"
                                style="width:100%; height:100%; object-fit:cover;" />
                            <i *ngIf="!instagramAccount.picture" class="pi pi-instagram text-white text-2xl"></i>
                        </div>
                        <div class="flex-1">
                            <div class="flex align-items-center gap-2">
                                <span class="font-bold">&#64;{{ instagramAccount.username }}</span>
                                <a [href]="'https://instagram.com/' + instagramAccount.username" target="_blank"
                                    class="text-500" title="Abrir no Instagram">
                                    <i class="pi pi-external-link text-sm"></i>
                                </a>
                            </div>
                            <div class="text-sm text-500 mb-2">{{ instagramAccount.name }}</div>
                            <div class="flex align-items-center gap-4">
                                <a class="cursor-pointer no-underline text-color" (click)="abrirPostagensInstagram()">
                                    <span class="font-bold">{{ instagramAccount.media_count ?? 0 }}</span>
                                    <span class="text-500 text-sm ml-1">posts</span>
                                </a>
                                <div>
                                    <span class="font-bold">{{ instagramAccount.followers_count ?? 0 | number }}</span>
                                    <span class="text-500 text-sm ml-1">seguidores</span>
                                </div>
                                <div>
                                    <span class="font-bold">{{ instagramAccount.follows_count ?? 0 | number }}</span>
                                    <span class="text-500 text-sm ml-1">seguindo</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noIg>
                    <p class="m-0 text-500 text-sm">Nenhuma conta Instagram vinculada a esta Página.</p>
                </ng-template>
                </div>
            </div>

            <p-dialog header="Posts do Instagram" [(visible)]="igPostsDialogVisible" [modal]="true"
                [dismissableMask]="true" styleClass="dialog1 ss-g-dialog-sized" appendTo="body">
                <div class="flex align-items-center gap-2 mb-3 pb-3 border-bottom-1 surface-border"
                    *ngIf="instagramAccount">
                    <img *ngIf="instagramAccount.picture" [src]="instagramAccount.picture" width="40" height="40"
                        class="border-circle" />
                    <div class="font-semibold">&#64;{{ instagramAccount.username }}</div>
                </div>
                <ng-container *ngIf="!loadingIgPosts; else loadingIgTemplate">
                    <div *ngIf="igPostsItems.length === 0" class="text-500 text-sm">
                        Nenhuma postagem encontrada nesta conta.
                    </div>
                    <!-- Grid de 2 colunas — mesmo motivo do dialog do Facebook logo acima:
                         a versão pequena/compacta depende da coluna estreitar o item.
                         Cada célula não é mais <a> clicável no card inteiro: vídeo com
                         controls e o swiper do carrossel são interativos, e cliques neles
                         (play, setas, bolinhas de paginação) borbulhariam pro <a> e abririam
                         o permalink sem querer. O link "Ver no Instagram" no rodapé cobre a
                         navegação. -->
                    <div class="grid" *ngIf="igPostsItems.length > 0">
                        <div class="col-12 sm:col-6" *ngFor="let post of igPostsItems">
                            <div class="card m-0 p-2 h-full shadow-none border-1 surface-border text-color-secondary">
                                <ng-container *ngIf="post.media_type === 'CAROUSEL_ALBUM'">
                                    <!-- Wrapper com position relative: garante que as setas fiquem sobre o swiper -->
                                    <div class="relative w-full h-10rem border-round overflow-hidden mb-2">
                                        <swiper [attr.data-uid]="post.id" [navigation]="false"
                                            [pagination]="{ clickable: true }" class="w-full h-full">
                                            <ng-template swiperSlide *ngFor="let child of post.children?.data">
                                                <ng-container [ngSwitch]="child.media_type">
                                                    <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                                        class="w-full h-full object-cover" />
                                                    <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls
                                                        muted class="w-full h-full object-cover"></video>
                                                </ng-container>
                                            </ng-template>
                                        </swiper>

                                        <div class="arrow-toggle-container left-arrow">
                                            <button class="circular-nav-button" pButton pRipple type="button"
                                                (click)="slideToPrev(post.id)">
                                                <i class="pi pi-chevron-left"></i>
                                            </button>
                                        </div>
                                        <div class="arrow-toggle-container right-arrow">
                                            <button class="circular-nav-button" pButton pRipple type="button"
                                                (click)="slideToNext(post.id)">
                                                <i class="pi pi-chevron-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>

                                <img *ngIf="post.media_url && post.media_type !== 'VIDEO' && post.media_type !== 'CAROUSEL_ALBUM'"
                                    [src]="post.media_url" class="w-full h-10rem object-cover border-round mb-2" />
                                <video *ngIf="post.media_url && post.media_type === 'VIDEO'" [src]="post.media_url"
                                    controls class="w-full h-10rem object-cover border-round mb-2"></video>
                                <div class="text-sm text-color mb-1"
                                    style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                    {{ post.caption || '(sem texto)' }}
                                </div>
                                <div class="text-xs text-500 mb-1">
                                    <i class="pi pi-calendar mr-1"></i>{{ post.timestamp | date:'dd/MM/yyyy HH:mm' }}
                                </div>
                                <a *ngIf="post.permalink" [href]="post.permalink" target="_blank"
                                    class="text-sm text-primary no-underline">Ver no Instagram</a>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="hasMoreIgPosts" class="text-center">
                        <button pButton type="button" [loading]="loadingMoreIgPosts"
                            label="Carregar mais" (click)="loadMoreIgPosts()" class="mt-2 load-more-btn"></button>
                    </div>
                </ng-container>
                <ng-template #loadingIgTemplate>
                    <p-skeleton width="100%" height="1.5rem" class="mb-2"></p-skeleton>
                    <p-skeleton width="100%" height="8rem" class="mb-2"></p-skeleton>
                    <p-skeleton width="60%" height="1rem"></p-skeleton>
                </ng-template>
            </p-dialog>

            <div class="flex align-items-center mt-3 mb-3"
                *ngIf="!showConectAccount && showAutoPublish && !displayAguarde">
                <p-inputSwitch [(ngModel)]="autoPublish" (onChange)="onToggleAutoPublish($event.checked)"
                    styleClass="mr-3"></p-inputSwitch>
                <div>
                    <div class="font-semibold text-lg">Auto-publicar</div>
                    <div class="text-sm text-500">Publicar mídias capturadas</div>
                </div>
            </div>

            <!-- Tabs -->
            <p-tabMenu [model]="tabs" [activeItem]="activeTab"
                *ngIf="!showConectAccount && !displayAguarde"></p-tabMenu>

            <!-- HASH TAG -->
            <div *ngIf="activeTab.label==='HashTag' && !showConectAccount && !displayAguarde" class="p-fluid p-grid">
                <div class="p-col-12">
                    <div class="mt-2 text-sm text-500">Busque por postagens contendo um hashtag (e.g.: #futebol).</div>
                </div>
                <div class="p-col-12 mb-3 mt-3">
                    <div class="mb-2"></div>
                    <label for="hashtag" class="ss-g-globalClassLabel">Hashtag (sem #)</label>
                    <div class="mb-2"></div>
                    <div class="p-inputgroup  mt-2">
                        <span class="p-inputgroup-addon">#</span>
                        <input id="hashtag" pInputText [(ngModel)]="hashtag" placeholder="ex: sunset"
                            (ngModelChange)="onHashtagChange($event)" />

                    </div>
                </div>
                <div class="p-col-12  mb-4">
                    <div class="mb-2"></div>
                    <label class="ss-g-globalClassLabel">Busca de Mídias</label>
                    <div class="mb-2"></div>
                    <div class="flex align-items-center">
                        <p-selectButton [(ngModel)]="mediaMode" [options]="mediaModeOptions" optionLabel="label"
                            optionValue="value" class="w-full"></p-selectButton>

                    </div>
                </div>


                <div class="p-col-12 ">
                    <div class="col-12 md-4 p-0 ss-l-wrapper-galeria">
                        <div class="mb-2"></div>
                        <label class="ss-g-globalClassLabel">Filtrar por tipo</label>
                        <div class="mb-2"></div>
                        <div #dialogGaleriaRef>
                            <p-multiSelect [appendTo]="'body'" [options]="mediaTypeOptions"
                                [filter]="false" class="ss-l-multiSelect-Galeria custom-multiselect-panel"
                                [(ngModel)]="selectedHashtagMediaTypes" defaultLabel="Todos"
                                (onChange)="applyHashTagFilter()">
                            </p-multiSelect>
                        </div>
                        <div class="mb-2"></div>
                    </div>

                    <button *ngIf="showContent" pButton type="button" class="mt-2 w-full"
                        [disabled]="LoadSearching || !hashtag || !instagramAccount || !selectedFacebookAccountId"
                        (click)="loadMoreHashTag(true)">
                        <ng-container *ngIf="LoadSearching; else searchIconInstagram">
                            <i class="pi pi-spinner pi-spin mr-2"></i>
                        </ng-container>
                        <ng-template #searchIconInstagram>
                            <i class="pi pi-search mr-2"></i>
                        </ng-template>
                        <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                    </button>


                </div>
            </div>

            <!-- TAGS -->
            <div *ngIf="activeTab.label==='Tags'" class="p-fluid">
                <div class="mt-2 text-sm text-500">Busque por postagens em que sua conta foi marcada (e.g.: Um post em que uma tag com seu @handle foi inserida).</div>
                <div class="mt-4">
                    <div class="grid center mb-2">
                        <div class="col-12 md-4">
                            <div class="mb-2"></div>
                            <label class="ss-g-globalClassLabel">Filtrar por tipo</label>
                            <div class="mb-2"></div>
                            <div #dialogGaleriaRef2>
                                <p-multiSelect [appendTo]="'body'" [options]="mediaTypeOptions"
                                    [filter]="false" [(ngModel)]="selectedTagsMediaTypes" defaultLabel="Todos"
                                    (onChange)="applyTagsFilter()">
                                </p-multiSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <button *ngIf="showContent" pButton type="button" class="mt-2 w-full"
                    [disabled]="LoadSearchingTags || !instagramAccount || !selectedFacebookAccountId"
                    (click)="loadMoreTags(true)">
                    <ng-container *ngIf="LoadSearchingTags; else searchIconTags">
                        <i class="pi pi-spinner pi-spin mr-2"></i>
                    </ng-container>
                    <ng-template #searchIconTags>
                        <i class="pi pi-search mr-2"></i>
                    </ng-template>
                    <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                </button>

            </div>

            <!-- TAB “Mídias” -->
            <div *ngIf="activeTab.label==='Mídias'" class="p-fluid ">
                <div class="mt-2 text-sm text-500">Liste as postagens de sua conta.</div>
                <div class="mt-4">
                    <div class="grid center mb-2">
                        <div class="col-12 md-4">
                            <div class="mb-2"></div>
                            <label class="ss-g-globalClassLabel">Filtrar por tipo</label>
                            <div class="mb-2"></div>
                            <div #dialogGaleriaRef3>
                                <p-multiSelect [appendTo]="'body'" [options]="mediaTypeOptions"
                                    [filter]="false" [(ngModel)]="selectedMediaTypes" defaultLabel="Filtrar por tipo"
                                    (onChange)="applyUserMediaFilter()">
                                </p-multiSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <button *ngIf="showContent" pButton type="button" class="mt-2 w-full"
                    [disabled]="LoadSearchingMedia || !instagramAccount || !selectedFacebookAccountId"
                    (click)="loadMoreUserMedia(true)">
                    <ng-container *ngIf="LoadSearchingMedia; else searchIconMedia">
                        <i class="pi pi-spinner pi-spin mr-2"></i>
                    </ng-container>
                    <ng-template #searchIconMedia>
                        <i class="pi pi-search mr-2"></i>
                    </ng-template>
                    <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                </button>

            </div>


            <!-- ABA “Stories” -->
            <div *ngIf="activeTab.label==='Stories'" class="p-fluid ">
                <div class="mt-2 text-sm text-500">Liste os stories de sua conta (apenas últimas 24 horas).</div>
                <div class="mt-4">
                    <div class="grid center mb-2">
                        <div class="col-12 md-4">
                            <div class="mb-2"></div>
                            <label class="ss-g-globalClassLabel">Filtrar por tipo</label>
                            <div class="mb-2"></div>
                            <div #dialogGaleriaRef4>
                                <p-multiSelect [appendTo]="'body'" [options]="mediaTypeOptions"
                                    [filter]="false" [(ngModel)]="selectedStoriesMediaTypes" defaultLabel="Todos"
                                    (onChange)="applyUserStoriesFilter()"></p-multiSelect>
                            </div>
                        </div>
                    </div>
                </div>


                <button *ngIf="showContent" pButton type="button" class="mt-2 w-full"
                    [disabled]="LoadSearchingStories || !instagramAccount || !selectedFacebookAccountId"
                    (click)="loadMoreUserStories(true)">
                    <ng-container *ngIf="LoadSearchingStories; else searchIconStories">
                        <i class="pi pi-spinner pi-spin mr-2"></i>
                    </ng-container>
                    <ng-template #searchIconStories>
                        <i class="pi pi-search mr-2"></i>
                    </ng-template>
                    <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
                </button>


            </div>

        </div>
    </div>
    <!-- aqui -->

</div>

<div class="card mb-4" *ngIf="!IsFeedTemp">
    <div *ngIf="!displayAguarde" class="cursor-pointer">
        <div class="flex align-items-center cursor-pointer" [class.mb-3]="!collapsed.igExtract" (click)="toggle('igExtract')">
            <i class="pi pi-instagram mr-2" style="font-size: 2.5rem;"></i>
            <div>
                <div class="font-bold">Instagram</div>
                <div class="text-sm text-500">Importar via URL (mídia deve ser PÚBLICA)</div>
            </div>

            <!-- seta à direita -->
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.igExtract }"></i>
        </div>
    </div>
    <div class="collapsible" [class.collapsed]="collapsed.igExtract">
        <div class="collapsible__inner">
            <div *ngIf="!displayAguarde">
                <div class="mb-2"></div>

                <div class="p-inputgroup mt-2 w-full">
                    <span class="p-inputgroup-addon"><i class="pi pi-link"></i></span>
                    <input pInputText class="w-full" [(ngModel)]="igUrl" placeholder="Cole a URL do Instagram"
                        (ngModelChange)="checkIgUrl()" />
                </div>
                <div class="flex justify-between items-center mt-1 text-sm">
                    <small class="p-error mr-2 w-full" [ngStyle]="{ visibility: igInvalid ? 'visible' : 'hidden' }">
                        URL do Instagram inválida!
                    </small>
                </div>

                <button *ngIf="showContent" pButton type="button" class="w-full mt-4"
                    [disabled]="!igUrl || extractingIg || igInvalid" (click)="extractInstagram(true)">
                    <ng-container *ngIf="extractingIg; else iconIg">
                        <i class="pi pi-spinner pi-spin mr-2"></i>
                    </ng-container>
                    <ng-template #iconIg>
                        <i class="pi pi-download mr-2"></i>
                    </ng-template>
                    <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Extrair</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="temp" *ngIf="!isFeed && hasSearched && !displayAguarde && extractedByUrl">
    <p-dataView styleClass="custom-dataview" [value]="media" layout="grid" [rows]="pageSize" *ngIf="showContent">
        <ng-template pTemplate="gridItem" let-item>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6 w-full">
                <div class="dv-item ">
                    <div class="card m-0 p-0 border-round shadow-none">

                        <!-- Checkbox -->
                        <div class="relative" style="z-index: 111;">
                            <p-checkbox [binary]="true" [ngModel]="isItemSelected(item)"
                                (onChange)="toggleSelection(item)" class="absolute">
                            </p-checkbox>
                        </div>

                        <!-- Mídia -->
                        <div class="w-full border-round-top overflow-hidden 1">
                            <ng-container *ngIf="item.media_type === 'CAROUSEL_ALBUM'">
                                <!-- Wrapper com position relative: garante que as setas fiquem sobre o swiper -->
                                <div class="relative w-full h-60 border-round-top overflow-hidden">
                                    <swiper [attr.data-uid]="item.id" [navigation]="false"
                                        [pagination]="{ clickable: true }" class="w-full h-full">
                                        <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                            <ng-container [ngSwitch]="child.media_type">
                                                <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                                    class="w-full h-full object-cover" />
                                                <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                                    class="w-full h-full object-cover"></video>
                                            </ng-container>
                                        </ng-template>
                                    </swiper>

                                    <!-- Agora essas setas estarão posicionadas corretamente -->
                                    <div class="arrow-toggle-container left-arrow">
                                        <button class="circular-nav-button" pButton pRipple
                                            (click)="slideToPrev(item.id)">
                                            <i class="pi pi-chevron-left"></i>
                                        </button>
                                    </div>

                                    <div class="arrow-toggle-container right-arrow">
                                        <button class="circular-nav-button" pButton pRipple
                                            (click)="slideToNext(item.id)">
                                            <i class="pi pi-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url"
                                class="w-full h-60 object-cover" />

                            <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url" controls
                                class="w-full h-60 object-cover">
                            </video>
                        </div>

                        <!-- Conteúdo -->
                        <div class="p-4">

                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                {{ item.caption }}

                            </div>
                            <!-- <span *ngIf="item.caption?.length > maxCaptionLength">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span> -->
                            <div class="flex align-items-center text-sm text-500">
                                <i class="pi pi-calendar mr-2"></i>
                                <span>{{ item.timestamp | date:'dd MMM yyyy' }}</span>
                            </div>

                            <div class="mt-3">
                                <a [href]="item.permalink" target="_blank" class="text-primary text-sm font-medium">
                                    Ver no Instagram
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="empty">
            <div class="text-center text-600 mt-4">
                Nenhum resultado encontrado.
            </div>
        </ng-template>
    </p-dataView>
</div>

<div class="temp" *ngIf="activeTab.label==='HashTag' && !showConectAccount && hasSearched && !displayAguarde && !extractedByUrl">
    <p-dataView styleClass="custom-dataview" [value]="media" layout="grid" [rows]="pageSize" *ngIf="showContent">
        <ng-template pTemplate="gridItem" let-item>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6 w-full">
                <div class="dv-item">
                    <div class="card m-0 p-0 border-round shadow-none">

                        <!-- Checkbox -->
                        <div class="relative" style="z-index: 111;">
                            <p-checkbox [binary]="true" [ngModel]="isItemSelected(item)"
                                (onChange)="toggleSelection(item)" class="absolute">
                            </p-checkbox>
                        </div>

                        <!-- Mídia -->
                        <div class="w-full border-round-top overflow-hidden 1">
                            <ng-container *ngIf="item.media_type === 'CAROUSEL_ALBUM'">
                                <!-- Wrapper com position relative: garante que as setas fiquem sobre o swiper -->
                                <div class="relative w-full h-60 border-round-top overflow-hidden">
                                    <swiper [attr.data-uid]="item.id" [navigation]="false"
                                        [pagination]="{ clickable: true }" class="w-full h-full">
                                        <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                            <ng-container [ngSwitch]="child.media_type">
                                                <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                                    class="w-full h-full object-cover" />
                                                <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                                    class="w-full h-full object-cover"></video>
                                            </ng-container>
                                        </ng-template>
                                    </swiper>

                                    <!-- Agora essas setas estarão posicionadas corretamente -->
                                    <div class="arrow-toggle-container left-arrow">
                                        <button class="circular-nav-button" pButton pRipple
                                            (click)="slideToPrev(item.id)">
                                            <i class="pi pi-chevron-left"></i>
                                        </button>
                                    </div>

                                    <div class="arrow-toggle-container right-arrow">
                                        <button class="circular-nav-button" pButton pRipple
                                            (click)="slideToNext(item.id)">
                                            <i class="pi pi-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url"
                                class="w-full h-60 object-cover" />

                            <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url" controls
                                class="w-full h-60 object-cover">
                            </video>
                        </div>

                        <!-- Conteúdo -->
                        <div class="p-4">

                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                {{ item.caption }}

                            </div>
                            <span *ngIf="item.caption?.length > maxCaptionLength">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span>
                            <div class="flex align-items-center text-sm text-500">
                                <i class="pi pi-calendar mr-2"></i>
                                <span>{{ item.timestamp | date:'dd MMM yyyy' }}</span>
                            </div>

                            <div class="mt-3">
                                <a [href]="item.permalink" target="_blank" class="text-primary text-sm font-medium">
                                    Ver no Instagram
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="empty">
            <div class="text-center text-600 mt-4">
                Nenhum resultado encontrado.
            </div>
        </ng-template>
    </p-dataView>
    <button *ngIf="hasMoreHashTag" pButton type="button" [loading]="LoadSearching" label="Carregar mais" (click)="loadMoreHashTag()"
        class="mt-2 load-more-btn">
    </button>
</div>
<div class="temp2" *ngIf="activeTab.label==='Tags' && hasSearched1">
    <p-dataView styleClass="custom-dataview" [value]="taggedMedia" layout="grid" [rows]="pageSizeTags"
        *ngIf="showContent">

        <ng-template pTemplate="gridItem" let-item>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6 w-full">
                <div class="dv-item ">
                    <div class="card m-0 p-0 border-round shadow-none">

                        <!-- Checkbox -->
                        <div class="relative" style="z-index: 111;">
                            <p-checkbox [binary]="true" [ngModel]="isItemSelected(item)"
                                (onChange)="toggleSelection(item)" class="absolute">
                            </p-checkbox>
                        </div>

                        <!-- Mídia -->
                        <div class="w-full border-round-top overflow-hidden">
                            <swiper *ngIf="item.media_type === 'CAROUSEL_ALBUM'" [navigation]="true"
                                [pagination]="{ clickable: true }" class="w-full h-60">
                                <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                    <ng-container [ngSwitch]="child.media_type">
                                        <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                            class="w-full h-full object-cover" />
                                        <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                            class="w-full h-full object-cover"></video>
                                    </ng-container>
                                </ng-template>
                            </swiper>

                            <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url"
                                class="w-full h-60 object-cover" />

                            <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url" controls
                                class="w-full h-60 object-cover">
                            </video>
                        </div>

                        <!-- Conteúdo -->
                        <div class="p-4">

                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                {{ item.caption }}
                            </div>

                            <span *ngIf="item.caption?.length > maxCaptionLength">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span>

                            <div class="flex align-items-center text-sm text-500 mt-2">
                                <i class="pi pi-calendar mr-2"></i>
                                <span>{{ item.timestamp | date:'dd MMM yyyy' }}</span>
                            </div>

                            <div class="mt-3">
                                <a [href]="item.permalink" target="_blank" class="text-primary text-sm font-medium">
                                    Ver no Instagram
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </ng-template>
    </p-dataView>


    <button *ngIf="hasMoreTags" pButton type="button" [loading]="LoadSearchingTags" label="Carregar mais" (click)="loadMoreTags()"
        class="mt-2 load-more-btn">
    </button>
</div>
<div class="temp3" *ngIf="activeTab.label==='Mídias' && hasSearched2">
    <p-dataView styleClass="custom-dataview" [value]="userMedia" layout="grid" [rows]="pageSizeUserMedia"
        *ngIf="showContent">
        <ng-template pTemplate="gridItem" let-item>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6 w-full">
                <div class="dv-item ">
                    <div class="card m-0 p-0 border-round shadow-none">

                        <!-- Checkbox -->
                        <div class="relative" style="z-index: 111;">
                            <p-checkbox [binary]="true" [ngModel]="isItemSelected(item)"
                                (onChange)="toggleSelection(item)" class="absolute">
                            </p-checkbox>
                        </div>

                        <!-- Mídia -->
                        <div class="w-full border-round-top overflow-hidden">
                            <swiper *ngIf="item.media_type === 'CAROUSEL_ALBUM'" [navigation]="true"
                                [pagination]="{ clickable: true }" class="w-full h-60">
                                <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                    <ng-container [ngSwitch]="child.media_type">
                                        <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                            class="w-full h-full object-cover" />
                                        <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                            class="w-full h-full object-cover"></video>
                                    </ng-container>
                                </ng-template>
                            </swiper>

                            <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url"
                                class="w-full h-60 object-cover" />

                            <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url" controls
                                class="w-full h-60 object-cover">
                            </video>
                        </div>

                        <!-- Conteúdo -->
                        <div class="p-4">

                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                {{ item.caption }}
                            </div>

                            <span *ngIf="item.caption?.length > maxCaptionLength">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span>

                            <div class="flex align-items-center text-sm text-500 mt-2">
                                <i class="pi pi-calendar mr-2"></i>
                                <span>{{ item.timestamp | date:'dd MMM yyyy' }}</span>
                            </div>

                            <div class="mt-3">
                                <a [href]="item.permalink" target="_blank" class="text-primary text-sm font-medium">
                                    Ver no Instagram
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>
    </p-dataView>


    <button *ngIf="hasMoreUserMedia" pButton type="button" [loading]="LoadSearchingMedia" label="Carregar mais" (click)="loadMoreUserMedia()"
        class="mt-2 load-more-btn">
    </button>
</div>
<div class="temp4" *ngIf="activeTab.label==='Stories' && hasSearched3">
    <p-dataView styleClass="custom-dataview" [value]="userStories" layout="grid" [rows]="pageSizeUserStories"
        *ngIf="showContent">
        <ng-template pTemplate="gridItem" let-item>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6 w-full">
                <div class="dv-item ">
                    <div class="card m-0 p-0 border-round shadow-none">

                        <!-- Checkbox -->
                        <div class="relative" style="z-index: 111;">
                            <p-checkbox [binary]="true" [ngModel]="isItemSelected(item)"
                                (onChange)="toggleSelection(item)" class="absolute">
                            </p-checkbox>
                        </div>

                        <!-- Mídia -->
                        <div class="w-full border-round-top overflow-hidden">
                            <swiper *ngIf="item.media_type === 'CAROUSEL_ALBUM'" [navigation]="true"
                                [pagination]="{ clickable: true }" class="w-full h-60">
                                <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                    <ng-container [ngSwitch]="child.media_type">
                                        <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                            class="w-full h-full object-cover" />
                                        <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                            class="w-full h-full object-cover"></video>
                                    </ng-container>
                                </ng-template>
                            </swiper>

                            <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url"
                                class="w-full h-60 object-cover" />

                            <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url" controls
                                class="w-full h-60 object-cover">
                            </video>
                        </div>

                        <!-- Conteúdo -->
                        <div class="p-4">

                            <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                {{ item.caption }}
                            </div>

                            <span *ngIf="item.caption?.length > maxCaptionLength">
                                … <a href="#" (click)="openDialog(item); $event.preventDefault()">ver mais</a>
                            </span>

                            <div class="flex align-items-center text-sm text-500 mt-2">
                                <i class="pi pi-calendar mr-2"></i>
                                <span>{{ item.timestamp | date:'dd MMM yyyy' }}</span>
                            </div>

                            <div class="mt-3">
                                <a [href]="item.permalink" target="_blank" class="text-primary text-sm font-medium">
                                    Ver no Instagram
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </ng-template>
    </p-dataView>

    <button *ngIf="hasMoreUserStories" pButton type="button" [loading]="LoadSearchingStories" label="Carregar mais" (click)="loadMoreUserStories()"
        class="mt-2 load-more-btn">
    </button>
</div>

<p-toast position="top-right"></p-toast>

<app-dialog-aguarde [visible]="displayAguarde" [baseZIndex]="16000"></app-dialog-aguarde>

<p-dialog [(visible)]="postDialogVisible" [modal]="true" [dismissableMask]="true" [closable]="true"
    [style]="{ width: '100%', maxWidth: '420px' }" class="dialog-article p-0 ss-g-dialog-sized" (onHide)="closePostDialog()">

    <ng-container *ngIf="selectedPost">
        <div class="card m-0 p-0 border-round shadow-none">

            <!-- Mídia -->
            <div class="w-full border-round-top overflow-hidden">
                <swiper *ngIf="selectedPost.media_type === 'CAROUSEL_ALBUM'" [pagination]="{ clickable: true }"
                    [navigation]="true" class="w-full h-60">
                    <ng-template swiperSlide *ngFor="let child of selectedPost.children?.data">
                        <ng-container [ngSwitch]="child.media_type">
                            <img *ngSwitchCase="'IMAGE'" [src]="child.media_url" class="w-full h-full object-cover" />
                            <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                class="w-full h-full object-cover"></video>
                        </ng-container>
                    </ng-template>
                </swiper>

                <img *ngIf="selectedPost.media_type === 'IMAGE' && selectedPost.source !== 'tiktok'"
                    [src]="selectedPost.media_url" class="w-full h-60 object-cover" />

                <video *ngIf="selectedPost.media_type === 'VIDEO' && selectedPost.source !== 'tiktok'"
                    [poster]="selectedPost.thumbnail_url" [src]="selectedPost.media_url"
                    class="w-full h-60 object-cover">
                </video>

                <div class="tiktok-player">
                    <iframe *ngIf="selectedPost.media_type === 'VIDEO' && selectedPost.source === 'tiktok'"
                        [src]="selectedPost.safe_player_url" frameborder="0" class="w-full"
                        allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
                    </iframe>
                </div>
            </div>

            <!-- Conteúdo -->
            <div class="p-4">

                <p class="text-700 text-sm mb-3 breakable white-space-pre-line">{{ selectedPost.caption }}</p>

                <div class="flex align-items-center text-sm text-500">
                    <i class="pi pi-calendar mr-2"></i>
                    <span>{{ selectedPost.timestamp | date:'dd MMM yyyy' }}</span>
                </div>

                <div class="mt-3">
                    <a [href]="selectedPost.permalink" target="_blank" class="text-primary text-sm font-medium">
                        Ver no {{ selectedPost.source === 'tiktok' ? 'TikTok' : 'Instagram' }}
                    </a>
                </div>
            </div>

        </div>
    </ng-container>

</p-dialog>

<p-dialog header="Limite de Hashtags Atingido" [(visible)]="showHashtagLimitDialog" [modal]="true" [closable]="true"
    class="ss-g-dialog-sized">
    <p>{{ hashtagLimitMessage }}</p>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="OK" (click)="showHashtagLimitDialog = false"></button>
    </ng-template>
</p-dialog>